import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { TextInput, Button, Group } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';
import './ChatbotModal.css';

export const MessageInput = forwardRef(({ onSend, disabled }, ref) => {
  const [input, setInput] = useState('');
  const inputRef = useRef(null);

  // Expose focus method to parent
  useImperativeHandle(ref, () => ({
    focus: () => {
      inputRef.current?.focus();
    }
  }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim() && !disabled) {
      onSend({ content: input.trim() });
      setInput('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="chatbot-input-form">
      <Group spacing="xs" style={{ width: '100%' }}>
        <TextInput
          ref={inputRef}
          placeholder="Ask about your health data..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          style={{ flex: 1 }}
          styles={{
            input: {
              borderRadius: '20px',
            },
          }}
        />
        <Button
          type="submit"
          disabled={disabled || !input.trim()}
          style={{ borderRadius: '50%', width: '40px', height: '40px', padding: 0 }}
        >
          <IconSend size={18} />
        </Button>
      </Group>
    </form>
  );
});

MessageInput.displayName = 'MessageInput';

